import { render, staticRenderFns } from "./ethnicity.vue?vue&type=template&id=431cad1a&scoped=true"
import script from "./ethnicity.vue?vue&type=script&lang=js"
export * from "./ethnicity.vue?vue&type=script&lang=js"
import style0 from "./ethnicity.vue?vue&type=style&index=0&id=431cad1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431cad1a",
  null
  
)

export default component.exports